<div class="d-flex gap-3 align-items-center mx-4">
  <fa-icon
    [icon]="faHome"
    size="lg"
    class="cursor-pointer"
    routerLink="/"
  ></fa-icon>

  <fa-icon [icon]="faAngleRight" size="1x"></fa-icon>

  @if (isDropdownMode) {
    <p-select
      class="border-0"
      [options]="actualTabs$ | async"
      optionLabel="title"
      [(ngModel)]="selectedTab"
      (onChange)="onSelectionChanged($event)"
      appendTo="body"
    ></p-select>
  } @else {
    <span>{{ (this.selectedTab$ | async)?.tabName }}</span>
  }
</div>
